import { render } from "./CourseCreationWizard.vue?vue&type=template&id=75ac6f67&scoped=true"
import script from "./CourseCreationWizard.vue?vue&type=script&lang=js"
export * from "./CourseCreationWizard.vue?vue&type=script&lang=js"

import "./CourseCreationWizard.vue?vue&type=style&index=0&id=75ac6f67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ac6f67"]])

export default __exports__